import styled from 'styled-components';

export const ContaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .date {
    font-size: 14px;
  }

  .searchBarContainer {
    display: flex;
    gap: 16px;
    width: 100%;
  }

  .contentHeader {
    p, a {
      font-style: normal;
      line-height: 24px;
    }
  }

  .contentLink {
    display: flex;
    margin-top: 16px;

    svg {
      margin-right: 4px;
    }
  }

  .contentCard {
    margin-top: 20px;

    display: flex;
    gap: 24px;
  }

`;

export const FiltersContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

export const Row = styled.tr`
  td {
    a {
      color: ${({ theme }) => theme.colors.gray[500]};
    }
  }
`;
